import { GetterTree } from 'vuex';
import { State } from './detail.store';

const getters: GetterTree<State, State> = {
  getCurrentSubType: state => {
    return state.currentSubType;
  },
  getWSMInstances: state => {
    return state.wsmInstances;
  },
  getCurrentWSMInstance: state => {
    return state.currentWSMInstance;
  }
};
export default getters;
